import { createSelector } from '@reduxjs/toolkit';
export const taskTypesSelector = (state) => state.taskTypes;
export const taskTypesDataSelector = createSelector(taskTypesSelector, (selector) => selector.data);
